import { useQuery } from "@tanstack/react-query";
import { getUserInfo } from "@/api/user";
import { UserInfo } from "@/interfaces/authentication";
import { useDelegationContext } from "@/hooks/delegation/useDelegationContext";
import { erIkkePersonligSession } from "@/lib/personligSession";

export const useNavbarUserMenu = () => {
  const { data: userInfo } = useQuery<UserInfo>({
    queryKey: ["userInfo"],
    queryFn: getUserInfo,
  });

  const isDelegatedSession = userInfo?.isDelegatedSession ?? false;
  const isDelegateOnly = Boolean(userInfo) && !userInfo?.id;
  const delegationContext = useDelegationContext(isDelegateOnly);

  const brugerNavn = isDelegatedSession
    ? (userInfo?.navn ?? null)
    : (userInfo?.mitIdNavn ??
      userInfo?.authenticatedMitIdName ??
      userInfo?.navn ??
      delegationContext.data?.authenticatedMitIdName ??
      null);

  const brugerVirksomhed = isDelegatedSession
    ? (userInfo?.authenticatedMitIdName ?? null)
    : (userInfo?.mitIdOrganisationNavn ?? null);

  const userSubtitles = [
    brugerVirksomhed
      ? isDelegatedSession
        ? `Logget ind som ${brugerVirksomhed}`
        : brugerVirksomhed
      : null,
  ].filter((s): s is string => Boolean(s));

  // "Mine oplysninger" er personlige: en firma- eller revisor-session har ingen person at vise, og
  // siden skrev "din profil er endnu ikke klar" til en advokat, der var logget ind med MitID
  // Erhverv for sin egen virksomhed (ADV-356).
  const showAccountLink = Boolean(
    userInfo &&
    brugerNavn &&
    !isDelegateOnly &&
    !isDelegatedSession &&
    !erIkkePersonligSession(userInfo),
  );

  return {
    userInfo,
    brugerNavn,
    userSubtitles,
    showAccountLink,
    menuUserInfo: !isDelegateOnly ? userInfo : undefined,
  };
};
